import React from "react";
import BaseLayout from "core/layouts/Base";
import Styles from "./oneRow.module.scss";

function OneRow({
  className,
  style,
  section,
  sectionStyle,
  isTopFillSpace,
  ...props
}) {
  return (
    <BaseLayout
      className={`${Styles["one-row-layout"]} ${className}`}
      style={style}
      {...props}
    >
      {({ Row }) => (
        <Row
          isFillSpace={isTopFillSpace}
          style={sectionStyle}
          className={`${Styles["section-container"]}`}
        >
          {section}
        </Row>
      )}
    </BaseLayout>
  );
}

export default OneRow;
